module.exports = __webpack_public_path__ + "fonts/Inter-100-latin28.30a274c.woff2";